import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { renderServerComponent } from "@tanstack/react-start/rsc";
import CookiePolicyContent from "src/components/policies/CookiePolicyContent";
import { metadataHead } from "src/lib/Metadata";
import { withHydrationMarker } from "src/lib/ServerContent";
import { renderCachedServerComponent } from "src/server/FlightCache";

// A server component, like the Terms (src/routes/_policies/terms.tsx).
const getCookiePolicyContent = createServerFn({ method: "GET" }).handler(() =>
  renderCachedServerComponent("policy:cookies", () =>
    renderServerComponent(withHydrationMarker(<CookiePolicyContent />)),
  ),
);

export const Route = createFileRoute("/_policies/cookies")({
  loader: () => getCookiePolicyContent(),
  // The text only changes with a deploy.
  staleTime: Number.POSITIVE_INFINITY,
  head: () =>
    metadataHead({
      title: "Cookie policy",
      description:
        "Learn which cookies CalmLens uses and manage your essential and functional cookie preferences.",
      alternates: { canonical: "/cookies" },
    }),
  component: () => <>{Route.useLoaderData()}</>,
});
